import * as copilotControl from 'graphql/copilotControl.graphql'
import { api, REQUEST_TYPE } from 'store/api'
import { buildOralHygienePatientsFilter } from 'components/CopilotControl/OralHygieneReport/oralHygieneReportLogic'
import { ModuleTags } from './consts'

const SEARCH_PATIENTS_PAGE_SIZE = 12

export const OralHygieneReport = api.injectEndpoints({
  endpoints: build => ({
    fetchOralHygieneAggregation: build.query({
      query: ({ accountOwnerId, pastXDays }) => ({
        type: REQUEST_TYPE.GET,
        path: `/copilot/v1/practices/${accountOwnerId}/aggregations/oralHygiene`,
        // Amplify serializes a present-but-undefined key as `pastXDays=`, which the service
        // rejects, so the All period must leave the key out entirely.
        queryParams: pastXDays ? { pastXDays } : {}
      }),
      providesTags: [ModuleTags.OralHygieneAggregation]
    }),
    fetchOralHygienePatients: build.infiniteQuery({
      infiniteQueryOptions: {
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages, lastPageParam) => (lastPage?.hasMore ? lastPageParam + 1 : undefined)
      },
      keepUnusedDataFor: 0,
      query: ({ queryArg, pageParam }) => {
        const { accountOwnerId, listType, categories = [], pastXDays } = queryArg

        return {
          type: REQUEST_TYPE.GRAPHQL,
          query: copilotControl.searchPatientSearchModels(copilotControl.fieldsByQuery.OralHygienePatientsQuery),
          queryName: 'searchPatientSearchModels',
          variables: {
            limit: SEARCH_PATIENTS_PAGE_SIZE,
            from: pageParam * SEARCH_PATIENTS_PAGE_SIZE,
            sort: { direction: 'desc', field: 'lastOhScanDate' },
            filter: buildOralHygienePatientsFilter({ accountOwnerId, listType, categories, pastXDays })
          }
        }
      },
      transformResponse: res => ({
        items: res?.searchPatientSearchModels?.items || [],
        hasMore: res?.searchPatientSearchModels?.items.length === SEARCH_PATIENTS_PAGE_SIZE
      })
    })
  })
})

export const { useFetchOralHygieneAggregationQuery, useFetchOralHygienePatientsInfiniteQuery } = OralHygieneReport
